var map = {
	"./A_graduation.png": 948,
	"./B_graduation.png": 5845,
	"./C_graduation.png": 7434,
	"./D_graduation.png": 9179,
	"./E_graduation.png": 4624,
	"./F_graduation.png": 1185,
	"./G_graduation.png": 6214,
	"./purpan_graduation.png": 6179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6596;